// REMOVE PENDING ONCE ALL ORDERS ARE OUT OF PENDING STATUS
export enum HardwareOrderStatus {
    ASSIGNED = "ASSIGNED",
    WORK_IN_PROGRESS = "WORK_IN_PROGRESS",
    PENDING = "PENDING",
    PENDING_QUOTE = "PENDING_QUOTE",
    PENDING_REQ_INFO = "PENDING_REQ_INFO",
    PENDING_APPROVAL = "PENDING_APPROVAL",
    PENDING_DELIVERY = "PENDING_DELIVERY",
    CANCELLED = "CANCELLED",
    COMPLETED = "COMPLETED",
    DENIED = "DENIED",
    APPROVED = "APPROVED",
    DELIVERED = "DELIVERED",
    REJECTED = "REJECTED",
    NEW = "NEW"
}

export enum MANAGE_ORDER_TABS {
    ALL_HAM_ORDERS = '',
    ITSE_HAM_ORDERS = 'itse',
    AMAZONIAN_HAM_ORDERS = 'amazonian',
    IT_SHOP_ORDERS = 'it-shop-orders',
    IT_SHOP_ORDERS_SUPPORT_REQUESTED = 'it-shop-orders-support-requested'
};
